__turbopack_context__.v({
  "blok-big-title": "ErrorPage-module__9bgDgW__blok-big-title",
  "blok-subtitle": "ErrorPage-module__9bgDgW__blok-subtitle",
  "blok-title": "ErrorPage-module__9bgDgW__blok-title",
  "buttons": "ErrorPage-module__9bgDgW__buttons",
  "devError": "ErrorPage-module__9bgDgW__devError",
  "errorPage": "ErrorPage-module__9bgDgW__errorPage",
  "pre": "ErrorPage-module__9bgDgW__pre",
  "title": "ErrorPage-module__9bgDgW__title",
});
